import Link from '@decisiv/ui-components/lib/components/Link';

import TextCell from 'components/TextCell';
import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedFleet } from '../..';

interface PlatformAccountNameCell {
  rowData: ManagedFleet;
}

const dealerGroupRegex = /^Dealer Group \d+$/;

export default function PlatformAccountNameCell({
  rowData: { id, name },
}: PlatformAccountNameCell) {
  const { searchString } = useSearchContext();

  /* istanbul ignore next -- @preserve */
  if (dealerGroupRegex.test(name)) {
    return <TextCell text={name} />;
  }
  return (
    <Link
      to={ROUTE_NAMES.forAdminManagementAccount(id)}
      text={<HighlightText text={name} searchText={searchString} />}
    />
  );
}
